import { ServiceDelay } from "@/Administration/Components/Services/ServiceDelay/ServiceDelay";
import { ServiceComboEditMode } from "@/Administration/Models/UI/Enums/Administration";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { Combobox, ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { RadioButton } from "@/Common/Components/Inputs/RadioButton";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SpanControl } from "@/Common/Components/SpanControl";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { BaseServiceComboDefinitionModel } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceComboItemType } from "@/Common/Models/Services/Enums/ServiceComboItemType";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { IServicePublishingConfig, ServicePublishingRule } from "@/Common/Models/Services/IServicePublishingConfig";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel, ServiceDefinitionModelEmployee } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { TimeframeToHours, TimeframeUnit } from "@/Common/Models/Timeframe";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

import img_icon_pictogrammemyle_emploisdutemps_assigne from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Assigne.png";
import img_icon_pictogrammemyle_emploisdutemps_clinique from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Clinique.png";
import img_icon_pictogrammemyle_emploisdutemps_organization from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Organization.png";
import img_icon_pictogrammemyle_emploisdutemps_ouvert from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Ouvert.png";
import img_icon_pictogrammemyle_emploisdutemps_rdvonline from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-RDVOnline.png";
import img_icon_pictogrammemyle_emploisdutemps_rdvurgent from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-RDVUrgent.png";
import img_icon_pictogrammemyle_emploisdutemps_site from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Site.png";
import img_icon_pictogrammemyle_emploisdutemps_teleconsultation from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Teleconsultation.png";
import img_loading from "@/Globals/_images/loading.gif";

interface IEditServiceComponentProps {
    currentEditedType: ServiceComboItemType;
    currentEditMode: ServiceComboEditMode;
    baseDefinitionModel: BaseServiceComboDefinitionModel;
    onCloseOperation: number;
}

class EditServiceComponentState {
    public editedDefinitionModel: BaseServiceComboDefinitionModel;
    public servicesFiltered: Immutable.List<SearchableItemModelT<ServiceModel>> = Immutable.List([]);
    public isLoading: boolean;
    public isQuestionnaireSelected: boolean;

    constructor(s: EditServiceComponentState = null) {
        if (s != null) {
            this.editedDefinitionModel = s.editedDefinitionModel;
            this.servicesFiltered = s.servicesFiltered;
            this.isLoading = s.isLoading;
        }
    }
}

class EditServiceComponent extends React.Component<IEditServiceComponentProps, EditServiceComponentState> {
    private maxWidthTextColumn: React.CSSProperties = { "maxWidth": "435px" };
    private helper: MyleHelper = new MyleHelper();
    private tableSaveOptionKey = "adminComboGrid";
    private id = "serviceEditComponent";
    private _employees: Immutable.List<SearchableItemModelT<Person>> = Immutable.List([]);
    private targetClienteleOptions = this.getTargetClienteleOptions().toImmutable();

    private get bookingTimeWindow(): string {
        const publishingConfig = this.props.baseDefinitionModel.GetPublishingConfig();

        switch (publishingConfig.rule) {
            case ServicePublishingRule.Immediate:
                return "";
            case ServicePublishingRule.StartOfDay:
                return "0";
            case ServicePublishingRule.FullDay:
                return TimeframeToHours(publishingConfig.timeframe).toString();
            default:
                return "";
        }
    }

    constructor(props: IEditServiceComponentProps) {
        super(props);

        const initialState = new EditServiceComponentState();
        initialState.editedDefinitionModel = props.baseDefinitionModel;
        initialState.isLoading = false;

        initialState.servicesFiltered = cacheStore.ServiceDefinitionCache.toArray()
            .filter(service => !service.IsAdHoc && service.Model.SiteId === props.baseDefinitionModel.GetSiteId())
            .map(p => new SearchableItemModelT<ServiceModel>(p.GetFullName(), p.Model.Id)).toImmutable();

        overlayStore.showOverlay("global-overlay");

        this.state = initialState;

        this._employees = this.filterEmployeeListOnSiteChange(props.baseDefinitionModel.GetSiteId());
    }

    public componentDidMount(): void {
        var elem = $("#" + this.id);
        var cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".p-header",
            stop: function() {
                elem.draggable("destroy");
                window.setTimeout(() => elem.draggable(dragOptions), 80);
            }
        };

        elem.draggable(dragOptions);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        var isFormValid = this.isValid();

        // get proper title
        let title: string = "";
        if (this.props.currentEditedType == ServiceComboItemType.Service) {
            if (this.props.currentEditMode == ServiceComboEditMode.Edit)
                title = cacheStore.GetString("EditServiceLabel");
            if (this.props.currentEditMode == ServiceComboEditMode.Create)
                title = cacheStore.GetString("AddServiceLabel");
        }
        if (this.props.currentEditedType == ServiceComboItemType.Combo) {
            if (this.props.currentEditMode == ServiceComboEditMode.Edit)
                title = cacheStore.GetString("EditComboLabel");
            if (this.props.currentEditMode == ServiceComboEditMode.Create)
                title = cacheStore.GetString("AddComboLabel");
        }

        return (
            <div className="request-popup popup-services" id={this.id} data-cy="EditServiceComponent">
                <div className="p-header ui-draggable-handle">
                    <a className="close" onClick={this.onCancelClick.bind(this)}>x</a>
                    <h3 className="uppercase">{title}</h3>
                </div>
                <div className="p-body">
                    <div className="popup-services-flex">

                        <div className="popup-services-leftside">
                            {this.renderLeftSide()}
                        </div>

                        <div className="popup-services-rightside">
                            {this.renderRightSide()}
                        </div>
                    </div>
                    {this.props.currentEditedType == ServiceComboItemType.Combo && (
                        <div className="popup-services-flex">
                            {this.renderServiceTable()}
                        </div>
                    )}
                    {this.props.currentEditedType == ServiceComboItemType.Combo && (
                        <div className="popup-services-flex">
                            <div className="popup-services-leftside">
                                {this.renderLastServiceRow()}
                            </div>
                            <div className="popup-services-rightside" />
                        </div>
                    )}

                </div>

                <div className="p-footer" style={{ "marginTop": "20px" }}>
                    <div className="popup-services space-between">
                        <div>{this.state.isLoading && <img src={img_loading} alt="loading" />}</div>

                        <div className="popup-services-flex flex-end">
                            <ButtonGroup spacing="sm">
                                <ButtonControl
                                    className="btn btn-default"
                                    onClick={this.onCancelClick.bind(this)}
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    variant="brand"
                                    onClick={this.onSaveClick.bind(this)}
                                    disabled={!isFormValid}
                                    label={cacheStore.GetString("SaveLabel")}
                                />
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRightSide(): JSX.Element {
        var self = this;
        var definitionModel = this.props.baseDefinitionModel;

        return (
            <div>

                <div className="popup-services-flex bottom-15">
                    <div className="row-large">

                        <div>
                            <CheckboxControl
                                checked={!definitionModel.GetIsNotifyPatientDisabledByDefault()}
                                onChange={checked => self.mutateState(s => s.editedDefinitionModel.SetIsNotifyPatientDisabledByDefault(!checked))}
                                label={cacheStore.GetString("NotifyPatientDefaultLabel")}
                                disabled={(cacheStore.ClinicSettings.EnableTelemedFeature && definitionModel.GetIsTeleconsultation())}
                            />
                        </div>
                        <div>
                            <img style={{ "marginTop": "-6px", "marginRight": "0px", "height": "30px" }} id="RVUrgenceLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_rdvurgent} />
                        </div>
                    </div>
                </div>

                <div className="popup-services-flex bottom-15">
                    <div className="row-large">

                        <div><CheckboxControl checked={definitionModel.GetUrgency()} onChange={this.onIsUrgentChange.bind(this)} label={cacheStore.GetString("RVUrgenceLabel")} /></div>
                        <div>
                            <img style={{ "marginTop": "-6px", "marginRight": "0px", "height": "30px" }} id="RVUrgenceLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_rdvurgent} />
                        </div>
                    </div>
                </div>

                <div className="popup-services-flex bottom-15">
                    <div className="row-large">
                        <div>
                            <CheckboxControl
                                checked={definitionModel.GetOnlineAvailability()}
                                onChange={() => {
                                    self.mutateState((_state: EditServiceComponentState) => {
                                        const def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                        def.SetOnlineAvailability(!def.GetOnlineAvailability());
                                        _state.editedDefinitionModel = def;
                                    });
                                }}
                                label={cacheStore.GetString("AvailableOnPortalLabel")}
                            />
                        </div>

                        <div>
                            <img style={{ "marginTop": "0px", "marginRight": "0px", "height": "30px" }} id="RVOnlineLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_rdvonline} />
                        </div>
                    </div>
                </div>

                {cacheStore.ClinicSettings.EnableIsTeleconsultationCheckbox && (
                    <div className="popup-services-flex bottom-15">
                        <div className="row-large">

                            <div>
                                <CheckboxControl
                                    checked={definitionModel.GetIsTeleconsultation()}
                                    onChange={checked => self.mutateState(s => s.editedDefinitionModel.SetIsTeleconsultation(checked))}
                                    label={cacheStore.GetString("TeleconsultationLabel")}
                                />
                            </div>
                            <div>
                                <img
                                    style={{ "marginTop": "-6px", "marginRight": "0px", "height": "30px" }}
                                    id="RVUrgenceLabel_handle_med"
                                    src={img_icon_pictogrammemyle_emploisdutemps_teleconsultation}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="popup-services-flex bottom-15">
                    <div className="popup-services-flex bottom-15">
                        {cacheStore.ClinicSettings.EnableAvailabilityRules
                            ? (
                                <div className="row-large" data-cy="PublicationRulesDropDown">
                                    <ServiceDelay
                                        value={definitionModel.GetPublishingConfig()}
                                        onChange={publishingConfig => {
                                            self.mutateState((_state: EditServiceComponentState) => {
                                                const def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                                def.SetPublishingConfig(publishingConfig);
                                                _state.editedDefinitionModel = def;
                                            });
                                        }}
                                    />
                                </div>
                            )
                            : (
                                <div className="row-large">
                                    <div className="divlabel" style={{ maxWidth: "75px" }}>
                                        <label className="no-margin">
                                            {cacheStore.GetString("PrisDansLesDerniersLabel")}
                                        </label>
                                    </div>

                                    <div style={{ marginLeft: "5px", width: "240px" }}>
                                        <Combobox
                                            id="_delayComboBox"
                                            HasEmptyItem={true}
                                            doInitialChangeOp={false}
                                            items={[
                                                new ComboBoxDropDownItem("0", cacheStore.GetString("SameDayLabel"), 0),
                                                new ComboBoxDropDownItem("24", "1 " + cacheStore.GetString("DayLabel"), 1),
                                                new ComboBoxDropDownItem("36", "1.5 " + cacheStore.GetString("DaysLabel"), 1.5),
                                                new ComboBoxDropDownItem("48", "2 " + cacheStore.GetString("DaysLabel"), 2),
                                                new ComboBoxDropDownItem("72", "3 " + cacheStore.GetString("DaysLabel"), 3),
                                                new ComboBoxDropDownItem("168", "1 " + cacheStore.GetString("WeekLabel"), 4),
                                                new ComboBoxDropDownItem("336", "2 " + cacheStore.GetString("WeeksLabel"), 5),
                                                new ComboBoxDropDownItem("504", "3 " + cacheStore.GetString("WeeksLabel"), 6),
                                                new ComboBoxDropDownItem("672", "4 " + cacheStore.GetString("WeeksLabel"), 7)
                                            ].toImmutable()}
                                            selectedCode={this.bookingTimeWindow}
                                            onChange={(value: string) => {
                                                const config: IServicePublishingConfig = { rule: ServicePublishingRule.Immediate, timeframe: null };
                                                const duration = parseInt(value);

                                                if (duration === 0) {
                                                    config.rule = ServicePublishingRule.StartOfDay;
                                                }
                                                else if (duration > 0) {
                                                    config.rule = ServicePublishingRule.FullDay;
                                                    config.timeframe = { Value: duration, Unit: TimeframeUnit.Hour };
                                                }

                                                self.mutateState((_state: EditServiceComponentState) => {
                                                    let def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                                    def.SetPublishingConfig(config);
                                                    _state.editedDefinitionModel = def;
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>

                <div className="popup-services-flex bottom-15">
                    <div className="row-large">
                        <div><label className="no-margin">{cacheStore.GetString("ClienteleLabel")}</label></div>
                        <div className="flex-container" style={{ marginLeft: "5px", width: "240px", justifyContent: "space-between" }}>

                            <div>
                                <RadioButton
                                    items={this.targetClienteleOptions}
                                    onePerLine={true}
                                    radioInputGroupId="_clientRadionButton"
                                    onChange={item =>
                                        self.mutateState((_state: EditServiceComponentState) => {
                                            const def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                            def.SetOnlineClienenteleCible(item.Value);
                                            _state.editedDefinitionModel = def;
                                        })
                                    }
                                    selectedItem={definitionModel.GetOnlineClienenteleCible()}
                                />
                            </div>
                            <div>
                                <div>
                                    <img style={{ "marginTop": "-10px", "marginRight": "10px", "height": "15px" }} id="Assigne_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_assigne} />
                                </div>
                                {this.targetClienteleOptions.some(p => p.Value == ServiceComboTargetClientele.Site) && (
                                    <div>
                                        <img style={{ "marginTop": "-5px", "marginLeft": "0px", "marginRight": "10px", "height": "15px" }} id="Clinique_handle_medSite" src={img_icon_pictogrammemyle_emploisdutemps_site} />
                                    </div>
                                )}
                                {this.targetClienteleOptions.some(p => p.Value == ServiceComboTargetClientele.Organization) && (
                                    <div>
                                        <img style={{ "marginTop": "-5px", "marginLeft": "0px", "marginRight": "10px", "height": "15px" }} id="Clinique_handle_medOrg" src={img_icon_pictogrammemyle_emploisdutemps_organization} />
                                    </div>
                                )}
                                <div>
                                    <img style={{ "marginTop": "-5px", "marginLeft": "0px", "marginRight": "10px", "height": "15px" }} id="Clinique_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_clinique} />
                                </div>
                                <div>
                                    <img style={{ "marginTop": "-5px", "marginRight": "10px", "height": "15px" }} id="Ouvert_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_ouvert} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {cacheStore.ClinicSettings.EnableCovidQuestionnaire && (
                    <div className="popup-services-flex bottom-15">
                        <div className="row-large">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("QuestionnaireLabel")}</label></div>

                            <div style={{ marginLeft: "5px", width: "240px" }}>
                                <Combobox
                                    HasEmptyItem={true}
                                    id="_ComboBoxQuestionnaire"
                                    items={cacheStore.AvailableQuestionnaires.map(x => new ComboBoxDropDownItem(x.QuestionnaireId, x.ShortName)).toImmutable()}
                                    selectedCode={definitionModel.GetQuestionnaireId()}
                                    onChange={(questionnaireId: string) => {
                                        self.mutateState((_state: EditServiceComponentState) => {
                                            if (!questionnaireId) {
                                                _state.editedDefinitionModel.SetQuestionnaireId(null);
                                                _state.isQuestionnaireSelected = false;
                                            }
                                            else {
                                                _state.editedDefinitionModel.SetQuestionnaireId(questionnaireId);
                                                _state.isQuestionnaireSelected = true;
                                            }
                                        });
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    }

    private getTargetClienteleOptions(): KeyValuePair<string, number>[] {
        const targetClienteleOptions = [
            new KeyValuePair(cacheStore.GetString("AssignedLabel"), ServiceComboTargetClientele.AssignedClientele)
        ];

        if (cacheStore.ClinicSettings.EnableBookingAlgorithmSiteAndOrganizationTargetOptions) {
            if (cacheStore.SiteCache.length > 1)
                targetClienteleOptions.push(new KeyValuePair(cacheStore.GetString("SiteDLabel"), ServiceComboTargetClientele.Site));

            if (cacheStore.ParentSiteCache.length > 1)
                targetClienteleOptions.push(new KeyValuePair(cacheStore.GetString("OrganizationLabel"), ServiceComboTargetClientele.Organization));
        }

        targetClienteleOptions.push(new KeyValuePair(cacheStore.GetString("MyleEnvironnementLabel"), ServiceComboTargetClientele.Clinic));
        targetClienteleOptions.push(new KeyValuePair(cacheStore.GetString("IsOpenLabel"), ServiceComboTargetClientele.Open));

        return targetClienteleOptions;
    }

    private renderLeftSide(): JSX.Element {
        var self = this;
        var definitionModel = this.state.editedDefinitionModel;
        var sitesComboBox: Immutable.List<ComboBoxDropDownItem> = Immutable.List(cacheStore.SiteCache.map(x => SitesModel.ToComboboxItem(x)));
        var specialityComboBox: Immutable.List<ComboBoxDropDownItem> = Immutable.List(cacheStore.GetClinicianSpecialityLookups().map(x => x.ToComboboxItem()));
        let isService: boolean;
        let serviceModel: ServiceDefinitionModel;
        let comboModel: ServiceComboDefinitionModel;
        if (this.state.editedDefinitionModel instanceof ServiceDefinitionModel) {
            serviceModel = this.state.editedDefinitionModel as ServiceDefinitionModel;
            isService = true;
        }
        else if (this.state.editedDefinitionModel instanceof ServiceComboDefinitionModel) {
            comboModel = this.state.editedDefinitionModel as ServiceComboDefinitionModel;
            isService = false;
        }

        if (!isService) {
            let def = this.state.editedDefinitionModel as ServiceComboDefinitionModel;

            def.ServiceDefinitions.forEach(x => {
                x.GetSite().Model.ClinicalName;
                x.Name;
                x.Duration;
                x.Employees.length;
            });
        }

        return (
            <div>
                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col">
                        <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameLabel") + " EN"}</label></div>
                    </div>
                    <div className="service-right-col" style={this.maxWidthTextColumn}>
                        <TextboxControl
                            debounceMs={200}
                            value={definitionModel.NameEN}
                            onChange={(value: string) => {
                                self.mutateState((_state: EditServiceComponentState) => {
                                    let def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                    def.NameEN = value;

                                    _state.editedDefinitionModel = def;
                                });
                            }}
                            style={{ marginRight: "10px" }}
                            className="form-control"
                            placeholder=""
                            id="txtNameEN"
                            valid={IsNullOrWhiteSpace(definitionModel.NameEN) == false}
                        />
                    </div>
                </div>
                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col">
                        <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameLabel") + " FR"}</label></div>
                    </div>
                    <div className="service-right-col" style={this.maxWidthTextColumn}>
                        <TextboxControl
                            debounceMs={200}
                            value={definitionModel.NameFR}
                            onChange={(value: string) => {
                                self.mutateState((_state: EditServiceComponentState) => {
                                    let def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                    def.NameFR = value;
                                    _state.editedDefinitionModel = def;
                                });
                            }}
                            style={{ marginRight: "10px" }}
                            className="form-control"
                            placeholder=""
                            id="txtNameFR"
                            valid={IsNullOrWhiteSpace(definitionModel.NameFR) == false}
                        />
                    </div>
                </div>
                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col">
                        <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameLabel") + " ES"}</label></div>
                    </div>
                    <div className="service-right-col" style={this.maxWidthTextColumn}>
                        <TextboxControl
                            debounceMs={200}
                            value={definitionModel.NameES}
                            onChange={(value: string) => {
                                self.mutateState((_state: EditServiceComponentState) => {
                                    let def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;
                                    def.NameES = value;
                                    _state.editedDefinitionModel = def;
                                });
                            }}
                            style={{ marginRight: "10px" }}
                            className="form-control"
                            placeholder=""
                            id="txtNameES"
                            valid={IsNullOrWhiteSpace(definitionModel.NameES) == false}
                        />

                    </div>
                </div>

                {isService && (
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("DurationLabel") + " (min)"}</label></div>
                        </div>
                        <div className="service-right-col" style={this.maxWidthTextColumn}>
                            <TextboxControl
                                debounceMs={200}
                                value={serviceModel.GetDefaultDurationMinutes().toString()}
                                IsNumeric={true}
                                onChange={(value: string) => {
                                    self.mutateState((_state: EditServiceComponentState) => {
                                        let def = _state.editedDefinitionModel as ServiceDefinitionModel;
                                        def.SetDurationMinutes(value);
                                        _state.editedDefinitionModel = def;
                                    });
                                }}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtDuration1"
                                valid={serviceModel.GetDefaultDurationMinutes() > 0}
                            />

                        </div>
                    </div>
                )}

                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col">
                        <div className="divlabel"><label className="no-margin">{cacheStore.GetString("SiteDLabel")}</label></div>
                    </div>
                    <div className="service-right-col" style={this.maxWidthTextColumn}>
                        <Combobox
                            HasEmptyItem={false}
                            id="_SiteComboBox"
                            disabled={this.props.currentEditMode != ServiceComboEditMode.Create}
                            items={sitesComboBox}
                            selectedCode={definitionModel.GetSiteId()}
                            maxNumberOptionCharacters={70}
                            onChange={rawSelectedId => {
                                const selectedId = GuidHelper.AsGuid(rawSelectedId);

                                self.mutateState((_state: EditServiceComponentState) => {
                                    let def = (self.props.currentEditedType == ServiceComboItemType.Combo) ? _state.editedDefinitionModel as ServiceComboDefinitionModel : _state.editedDefinitionModel;

                                    // clear employees or services if we switch site
                                    if (selectedId != self.state.editedDefinitionModel.GetSiteId()) {
                                        if (comboModel != null) {
                                            comboModel.ServiceDefinitions = [];
                                            comboModel.PrimaryServiceDefinitionId = null;
                                        }
                                        if (serviceModel != null) {
                                            serviceModel.Employees = [];
                                        }
                                    }

                                    def.SetSiteId(selectedId);

                                    _state.servicesFiltered = Immutable.List<SearchableItemModelT<ServiceModel>>(
                                        cacheStore.ServiceDefinitionCache
                                            .filter(x => !x.IsAdHoc && x.Model.SiteId === selectedId)
                                            .map(x => new SearchableItemModelT<ServiceModel>(
                                                x.Name + " - ( " + x.GetDefaultDurationMinutes() + " min. ) - " + cacheStore.GetLocalizedValueByLookupId(x.Model.SpecializationLookupId),
                                                x.Model.Id,
                                                new ServiceModel(x.Model.Id, x)
                                            ))
                                    );

                                    this._employees = this.filterEmployeeListOnSiteChange(selectedId);
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col">
                        <div className="divlabel"><label className="no-margin">{cacheStore.GetString("SpecialityLabel")}</label></div>
                    </div>
                    <div className="service-right-col" style={this.maxWidthTextColumn}>
                        <Combobox
                            HasEmptyItem={false}
                            id="_SpecialityComboBox"
                            items={specialityComboBox}
                            selectedCode={definitionModel.GetSpecializationId()}
                            onChange={(selectedId: string) => {
                                self.mutateState((_state: EditServiceComponentState) => {
                                    let def = _state.editedDefinitionModel as ServiceDefinitionModel;
                                    def.SetSpecializationId(selectedId);
                                    _state.editedDefinitionModel = def;
                                });
                            }}
                        />
                    </div>
                </div>

                {isService && (
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("PriceLabel")}</label></div>
                        </div>
                        <div className="service-right-col" style={this.maxWidthTextColumn}>
                            <div>
                                <TextboxControl
                                    debounceMs={200}
                                    value={definitionModel.GetPrice() > 0 ? definitionModel.GetPrice().toString() : ""}
                                    onChange={(value: number) => {
                                        self.mutateState((_state: EditServiceComponentState) => {
                                            let def = _state.editedDefinitionModel;
                                            def.SetPrice(value);
                                            _state.editedDefinitionModel = def;
                                        });
                                    }}
                                    IsNumeric
                                    style={{ marginRight: "10px" }}
                                    className="form-control"
                                    placeholder=""
                                    id="txtPrice1"
                                />
                            </div>
                        </div>
                    </div>
                )}

                {isService && (
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel">
                                <label className="no-margin">
                                    {cacheStore.GetString("EmployeesLabel")}
                                </label>
                            </div>
                        </div>
                        <div className="service-right-col" style={this.maxWidthTextColumn}>
                            <div>
                                <TextboxControl
                                    debounceMs={200}
                                    value=""
                                    autoCompleteItems={this._employees}
                                    onAutoCompleteSelectCallBack={(code: string, value: Person) => {
                                        self.mutateState((_state: EditServiceComponentState) => {
                                            let def = _state.editedDefinitionModel as ServiceDefinitionModel;
                                            self.addEmployee(value);
                                            _state.editedDefinitionModel = def;
                                        });
                                    }}
                                    onAutoCompleteSelectClearTextBox={true}
                                    style={{ marginRight: "10px" }}
                                    placeholder=""
                                    id="txtEmployees"
                                />
                            </div>
                        </div>
                    </div>
                )}

                {isService && (
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col" />
                        <div className="service-right-col" style={this.maxWidthTextColumn}>
                            <div className="scrollable vertical-scroll-only" style={{ height: "150px", overflowY: "auto" }}>
                                {serviceModel.Employees.map((employee, idx) => (
                                    <div key={"empoyee_" + idx} className="flex-container" style={{ justifyContent: "space-between", paddingRight: "7px" }}>
                                        <div>{employee.NameWithPrefix}</div>
                                        <div className="red-text bold pointer" onClick={self.removeEmployee.bind(this, employee)}>X</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {!isService && (
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("ServicesLabel")}</label></div>
                        </div>
                        <div className="service-right-col" style={this.maxWidthTextColumn}>
                            <div>
                                <TextboxControl
                                    value=""
                                    autoCompleteItems={self.state.servicesFiltered}
                                    onAutoCompleteSelectCallBack={(code, value: ServiceModel) => {
                                        self.mutateState((_state: EditServiceComponentState) => {
                                            let def = _state.editedDefinitionModel as ServiceComboDefinitionModel;
                                            let primary = def.ServiceDefinitions == null || def.ServiceDefinitions.length == 0;
                                            let alreadyThere = def.ServiceDefinitions
                                                .some((x: ServiceDefinitionModel) => x.Model.Id == value.ServiceDefinitionModel.Model.Id);
                                            if (!alreadyThere) {
                                                def.AddServiceDefinition(value.ServiceDefinitionModel.Model.Id, primary);
                                                _state.editedDefinitionModel = def;
                                            }
                                        });
                                    }}
                                    onAutoCompleteSelectClearTextBox={true}
                                    style={{ marginRight: "10px" }}
                                    placeholder=""
                                    id="txtServices"
                                    valid={!(comboModel.ServiceDefinitions == null || comboModel.ServiceDefinitions.length == 0)}
                                />

                            </div>
                        </div>
                    </div>
                )}

            </div>
        );
    }

    private renderServiceTable(): JSX.Element {
        const definitionModel = this.state.editedDefinitionModel as ServiceComboDefinitionModel;
        const columnsOptions = this.helper.loadTableColumnOptionsFromSettings(this.tableSaveOptionKey, this.getMyleTableColumnsDefaultOptions());
        const tableRenderOptions = this.loadTableRenderOptions(columnsOptions);
        const tableColumns = this.getTableColumns(columnsOptions);

        return (
            <div id="posref2" className="popup-services-flex bottom-5 ws-scrollabe" style={{ maxHeight: "200px" }}>
                <div className="service-left-label-col" />
                <div className="service-right-col admin-combotable">
                    <MyleTable
                        TableRenderOptions={tableRenderOptions}
                        TableId="adminservicecombopopuptable"
                        Columns={tableColumns}
                        DataSource={Immutable.List(definitionModel.ServiceDefinitions)}
                        RowClickOperation={LocalOperations.AdministrationServiceCombo.ServiceDefinitionEdit_Open}
                        SaveOptionskeyTarget={this.tableSaveOptionKey}
                        ColumnReorderTarget={MyleTableTarget.Unassigned}
                        ColumnSortTarget={MyleTableTarget.Unassigned}
                        PosRefClassName="posref2"
                    />

                </div>
            </div>
        );
    }

    private renderLastServiceRow(): JSX.Element {
        var self = this;
        var definitionModel = this.state.editedDefinitionModel as ServiceComboDefinitionModel;

        return (
            <div>

                <div className="popup-services-flex bottom-5">
                    <div className="service-left-label-col" />
                    <div className="service-right-col" style={{ display: "flex", justifyContent: "stretch", "flexGrow": 1 }}>
                        <div style={{ width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex" }}>
                                    <span style={{ paddingRight: "10px" }}>
                                        {cacheStore.GetString("PriceLabel")}
                                    </span>
                                    <TextboxControl
                                        debounceMs={200}
                                        value={definitionModel.GetPrice() > 0 ? definitionModel.GetPrice().toString() : ""}
                                        IsNumeric={true}
                                        onChange={(value: number) => {
                                            self.mutateState((_state: EditServiceComponentState) => {
                                                let def = _state.editedDefinitionModel;
                                                def.SetPrice(value);
                                                _state.editedDefinitionModel = def;
                                            });
                                        }}
                                        style={{ marginRight: "10px", width: "100px", display: "inline" }}
                                        placeholder=""
                                        id="txtPrice1"
                                    />

                                    <CheckboxControl
                                        checked={definitionModel.Model.IsPriceIncludingTaxes}
                                        onChange={() => {
                                            self.mutateState((_state: EditServiceComponentState) => {
                                                let def = _state.editedDefinitionModel as ServiceComboDefinitionModel;
                                                def.ToggleIsPriceIncludingTaxes();
                                                _state.editedDefinitionModel = def;
                                            });
                                        }}
                                        label={cacheStore.GetString("TaxesLabel")}
                                    />

                                </div>
                                <div>
                                    <span style={{ paddingLeft: "20px", paddingRight: "10px" }}>
                                        {cacheStore.GetString("DurationLabel")}: {this.state.editedDefinitionModel.GetDefaultDurationMinutes()} min
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(Mutation: (s: EditServiceComponentState) => void): void {
        var state = new EditServiceComponentState(this.state);
        state.editedDefinitionModel = this.state.editedDefinitionModel; // Calls will just modify it, not create a new one, so be start by taking a copy;
        Mutation(state);
        this.setState(state);
    }

    private addEmployee(employee: Person): void {
        var serviceDefinitionModel = this.state.editedDefinitionModel as ServiceDefinitionModel;
        var isAlreadyThere = serviceDefinitionModel.Employees.some(x => x.ContactFacetId == employee.ContactFacetId);

        if (isAlreadyThere == false) {
            this.mutateState((_state: EditServiceComponentState) => {
                let def = _state.editedDefinitionModel as ServiceDefinitionModel;

                var newEmployeeList = def.Employees.map(x => x);
                newEmployeeList.push(new ServiceDefinitionModelEmployee(employee.ContactFacetId, employee.NameWithPrefix));

                def.Employees = newEmployeeList;
                def.SortEmployees();

                _state.editedDefinitionModel = def;
            });
        }
    }

    private removeEmployee(employee: ServiceDefinitionModelEmployee): void {
        this.mutateState((_state: EditServiceComponentState) => {
            let def = _state.editedDefinitionModel as ServiceDefinitionModel;

            var newEmployeeList = def.Employees.filter(x => x.ContactFacetId != employee.ContactFacetId);
            def.Employees = newEmployeeList;
            def.SortEmployees();
            _state.editedDefinitionModel = def;
        });
    }

    private removeService(service: ServiceDefinitionModel): void {
        var comboDef = this.state.editedDefinitionModel as ServiceComboDefinitionModel;

        comboDef.ServiceDefinitions = comboDef.ServiceDefinitions
            .filter((x: ServiceDefinitionModel) => x.Model.Id != service.Model.Id);

        var s = new EditServiceComponentState(this.state);
        s.editedDefinitionModel = comboDef;
        this.setState(s);
    }

    private setPrimaryService(serviceId: Guid): void {
        var comboDef = this.state.editedDefinitionModel as ServiceComboDefinitionModel;
        comboDef.PrimaryServiceDefinitionId = serviceId;

        var s = new EditServiceComponentState(this.state);
        s.editedDefinitionModel = comboDef;
        this.setState(s);
    }

    private saveServiceDefinition(): void {
        var serviceDefinitionModel = this.state.editedDefinitionModel as ServiceDefinitionModel;
        var operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SaveService_Click);
        operation.AddItem("serviceDefinition", serviceDefinitionModel);
        LocalEventDispatcher.dispatch(operation);
    }

    private saveComboDefinition(): void {
        var comboModel = this.state.editedDefinitionModel as ServiceComboDefinitionModel;
        var operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SaveCombo_Click);
        operation.AddItem("comboDefinition", comboModel);
        LocalEventDispatcher.dispatch(operation);
    }

    private getMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        var cols: MyleTableColumnOptions[] = [];

        var c_opt0 = new MyleTableColumnOptions();
        c_opt0.HeaderText = cacheStore.GetString("SiteDLabel");
        c_opt0.FieldName = "Site";
        c_opt0.columnClass = "col-left-align";
        c_opt0.WidthPercentageDefault = 30;

        var c_opt1 = new MyleTableColumnOptions();
        c_opt1.HeaderText = cacheStore.GetString("ServiceLabel");
        c_opt1.FieldName = "Name";
        c_opt1.columnClass = "col-left-align";
        c_opt1.WidthPercentageDefault = 40;

        var c_opt2 = new MyleTableColumnOptions();
        c_opt2.HeaderText = cacheStore.GetString("DurationLabel");
        c_opt2.FieldName = "Duration";
        c_opt2.columnClass = "col-center-align";
        c_opt2.WidthPercentageDefault = 10;

        var c_opt3 = new MyleTableColumnOptions();
        c_opt3.HeaderText = cacheStore.GetString("NbResourcesLabel");
        c_opt3.FieldName = "NbEmployees";
        c_opt3.columnClass = "col-center-align";
        c_opt3.WidthPercentageDefault = 10;

        var c_opt4 = new MyleTableColumnOptions();
        c_opt4.HeaderText = cacheStore.GetString("PrimaryServiceLabel");
        c_opt4.FieldName = "IsPrimaryService";
        c_opt4.columnClass = "col-center-align";
        c_opt4.WidthPercentageDefault = 10;

        cols.push(c_opt0);
        cols.push(c_opt1);
        cols.push(c_opt2);
        cols.push(c_opt3);
        cols.push(c_opt4);

        return cols;
    }

    private getTableColumns(columnsOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        const comboModel = this.state.editedDefinitionModel as ServiceComboDefinitionModel;

        return MyleTableColumn.buildList<ServiceDefinitionModel>(
            columnsOptions,
            column => {
                switch (column.FieldName) {
                    case "Site":
                        return {
                            renderCell: item => (
                                <div><SpanControl text={item.GetSite().Model.ClinicalName} /> </div>
                            )
                        };

                    case "Name":
                    case "Service":
                        return {
                            renderCell: item => (
                                <div><SpanControl text={item.Name} /> </div>
                            )
                        };

                    case "Duration":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.GetDefaultDurationMinutes().toString()} /> </div>
                            ),
                            renderHeader: () => (
                                <div style={{ textAlign: "center" }}> <SpanControl text={column.HeaderText} /> </div>
                            )
                        };

                    case "NbEmployees":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.Employees.length.toString()} /> </div>
                            ),
                            renderHeader: () => (
                                <div style={{ textAlign: "center" }}> <SpanControl text={column.HeaderText} /> </div>
                            )
                        };

                    case "IsPrimaryService":
                        return {
                            renderCell: item => (
                                <span>
                                    <input
                                        onChange={this.setPrimaryService.bind(this, item.Model.Id)}
                                        id={"_rbPrimary_" + item.Model.Id}
                                        type="checkbox"
                                        name={item.Model.Id}
                                        value={item.Model.Id}
                                        checked={item.Model.Id == comboModel.PrimaryServiceDefinitionId}
                                    />

                                    <span onClick={this.removeService.bind(this, item)} className="pointer" style={{ color: "red", fontWeight: "bold", float: "right", paddingRight: "5px" }}>X</span>
                                </span>
                            ),
                            renderHeader: () => <div style={{ textAlign: "center" }}> <SpanControl text={column.HeaderText} /> </div>
                        };
                }
            },
            false
        );
    }

    private loadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        var defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 700,

            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: false,
            Autoresize: true,
            OnColumnWidthChange: null
        };

        return Immutable.fromJS(defaultTablePluginOptions);
    }

    private onCancelClick(): void {
        if (this.props.onCloseOperation != null) {
            var operation = new LocalEvent(this.props.onCloseOperation);
            LocalEventDispatcher.dispatch(operation);
        }
    }

    private onIsUrgentChange(): void {
        var s = new EditServiceComponentState(this.state);
        s.editedDefinitionModel.SetUrgency(!s.editedDefinitionModel.GetUrgency());
        this.setState(s);
    }

    private onSaveClick(): void {
        if (this.state.editedDefinitionModel instanceof ServiceDefinitionModel) {
            this.saveServiceDefinition();
        }
        else if (this.state.editedDefinitionModel instanceof ServiceComboDefinitionModel) {
            this.saveComboDefinition();
        }
    }

    private isValid(): boolean {
        var result = true;

        if (this.props.currentEditedType == ServiceComboItemType.Service) {
            var service = this.props.baseDefinitionModel as ServiceDefinitionModel;
            if (IsNullOrWhiteSpace(service.NameEN) || IsNullOrWhiteSpace(service.NameFR) || IsNullOrWhiteSpace(service.NameES))
                return false;
            if (service.GetDefaultDurationMinutes() <= 0)
                return false;
        }
        else if (this.props.currentEditedType == ServiceComboItemType.Combo) {
            var combo = this.props.baseDefinitionModel as ServiceComboDefinitionModel;
            if (IsNullOrWhiteSpace(combo.NameEN) || IsNullOrWhiteSpace(combo.NameFR) || IsNullOrWhiteSpace(combo.NameES))
                return false;
            if (combo.ServiceDefinitions == null || combo.ServiceDefinitions.length == 0)
                return false;
        }

        return result;
    }

    private filterEmployeeListOnSiteChange(siteId: string): Immutable.List<SearchableItemModelT<Person>> {
        let filteredBySitesEmployees = [];
        cacheStore.Clinicians.forEach(c => {
            let hasSitePermission = c.EmployeeModel.AssociatedSites.filter(s => s === siteId);
            if (hasSitePermission.length > 0) {
                filteredBySitesEmployees.push(new SearchableItemModelT<Person>(c.NameWithPrefix, c.ContactId, c));
            }
        });

        return Immutable.List(filteredBySitesEmployees);
    }
}

export { EditServiceComponent, IEditServiceComponentProps };
